import { getList } from '@/api/personalCenter/layout';

let cachedUrl = null;
let pendingPromise = null;

export function clearExclusiveCustomerImgCache() {
	if (cachedUrl) {
		window.URL.revokeObjectURL(cachedUrl);
		cachedUrl = null;
	}
	pendingPromise = null;
}

export function getExclusiveCustomerImg() {
	if (cachedUrl) {
		return Promise.resolve(cachedUrl);
	}
	if (pendingPromise) {
		return pendingPromise;
	}
	pendingPromise = getList()
		.then(res => {
			cachedUrl = window.URL.createObjectURL(res.data);
			return cachedUrl;
		})
		.finally(() => {
			pendingPromise = null;
		});
	return pendingPromise;
}
